import { render, staticRenderFns } from "./ReviewOverview.vue?vue&type=template&id=6f131c39&scoped=true"
import script from "./ReviewOverview.vue?vue&type=script&lang=js"
export * from "./ReviewOverview.vue?vue&type=script&lang=js"
import style0 from "./ReviewOverview.vue?vue&type=style&index=0&id=6f131c39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f131c39",
  null
  
)

export default component.exports